/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Inventory = "inventory",
    Map = "map",
    Register = "register",
    MiniGame = "miniGame",
    CharacterProfile = "characterProfile",
    Login = "login",
};
